import { fixedUi } from '@/i18n/fixedUi';
import { localizedSiteLabel } from '@/i18n/catalogDisplayText';
import React, { useEffect, useMemo } from 'react';

export const TIKTOK_WORKSPACE_SITE_ALL = '';

/**
 * TikTok 工作区产品模板：站点维度 Tab（全部站点 + 可售站点）。
 */
export default function TiktokWorkspaceSiteTabs({
  siteAbbr = TIKTOK_WORKSPACE_SITE_ALL,
  sites = [],
  loading = false,
  disabled = false,
  className = '',
  ariaLabel = fixedUi('上架站点'),
  onChange,
}) {
  const tabs = useMemo(() => ([
    { key: TIKTOK_WORKSPACE_SITE_ALL, get label() { return fixedUi("全部站点"); } },
    ...(Array.isArray(sites) ? sites : []).filter((row) => row?.siteAbbr).map((row) => ({
      key: String(row.siteAbbr),
      label: row.siteName && row.siteName !== '—'
        ? String(row.siteName)
        : String(row.siteAbbr),
    })),
  ]), [sites]);

  useEffect(() => {
    if (!siteAbbr || loading) return;
    const exists = tabs.some((tab) => tab.key === siteAbbr);
    if (!exists) onChange?.(TIKTOK_WORKSPACE_SITE_ALL);
  }, [siteAbbr, tabs, loading, onChange]);

  return (
    <div
      className={['tko-status-tabs', 'tko-status-tabs--sites', className].filter(Boolean).join(' ')}
      role="tablist"
      aria-label={ariaLabel}
    >
      {tabs.map((tab) => {
        const active = siteAbbr === tab.key;
        return (
          <button
            key={tab.key || 'all'}
            type="button"
            role="tab"
            aria-selected={active}
            className={`tko-status-tab${active ? ' tko-status-tab--active' : ''}`}
            disabled={disabled || loading}
            title={tab.key || fixedUi("全部站点")}
            onClick={() => {
              if (siteAbbr === tab.key) return;
              onChange?.(tab.key);
            }}
          >
            {localizedSiteLabel(tab.label)}
          </button>
        );
      })}
    </div>
  );
}
